import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {FormControl , FormGroup , Validators} from '@angular/forms';
import {DomSanitizer} from "@angular/platform-browser";
import {OrganizationsService} from "../../../../../core/services/organizations.service";
import {FrontUserService} from "../../../../../core/services/frontUsers.service";
import {EventTypeService} from "../../../../../core/services/eventType.service";
import {ToastrService } from "ngx-toastr";
import moment from 'moment';

@Component({
    selector: 'user-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class UserDialogComponent implements OnInit {
  users = [];
  targetGroups = [];
  all = false;
  msg;

  constructor (private organizationService: OrganizationsService ,
               public dialog: MatDialog ,
               public toastr: ToastrService  ,
               private eventService: EventTypeService ,
               private userService: FrontUserService ,
               public dialogRef: MatDialogRef<UserDialogComponent> ,
               @Inject(MAT_DIALOG_DATA) private data: any , private satinaizer: DomSanitizer) {
    this.organizationService.getOldUser(data.oldID , data.id).subscribe((res: any) => {
      this.msg = res.msg;
      if (res && res.msg === 'done') {
        this.users = res[ 'users' ];
      }
    });
    this.userService.getTargetGroup().subscribe((res: any) => {
      this.targetGroups = res.targetGroups;
    });

  }

  ngOnInit () {

  }

  openTgDialog (item , index) {
    // const dialogRef = this.dialog.open(UserDialog , {
    //   width: '70vw' ,
    //   data: {
    //     item: item ,
    //     targetGroups: this.targetGroups,
    //   }
    // });
    //
    // dialogRef.afterClosed().subscribe((result) => {
    //   console.log(result);
    //   if (result) {
    //
    //
    //   }
    // });
  }


  selectAll () {
    console.log(this.all);
    for (let i = 0; i < this.users.length; i++) {
      if (!this.users[ i ].imported) {
        this.users[ i ].selected = this.all;
      }
    }
  }

  checkAll () {
    let count = 0;
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[ i ].selected && !this.users[ i ].imported) {
        count++;
      }
    }
    if (this.users.length === count) {
      this.all = true;
    } else {
      this.all = false;
    }
  }

  saveEvent () {
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[ i ].selected) {
        console.log(this.users[ i ]);
        if (this.users[i].children && this.users[i].children.length) {
          this.users[i].children = this.users[i].children.toString();
        }
        this.organizationService.importUser(this.users[ i ]).subscribe((res: any) => {
          if (res) {
            this.toastr.success('User ' + res.firstName + ' ' + res.lastName + ' added' , 'Success!');
          }
        });
      }
    }
    this.dialogRef.close();
  }


}

@Component({
    selector: 'user-example-dialog',
    templateUrl: 'user-dialog.html',
    styles: [`.width-50 {
    width: 50%;
    padding: 10px;
  }

  .width-100 {
    width: 100%;
    padding: 10px;
  }

  .width-75 {
    width: 75%;
    padding: 10px;
  }

  .width-33 {
    width: 33%;
    padding: 10px;
  }

  .width-25 {
    width: 25%;
    padding: 10px;
  }`],
    standalone: false
})
export class UserDialog {
  public form: FormGroup = new FormGroup({
    firstName: new FormControl('' , Validators.required) ,
    description: new FormControl('' , Validators.required) ,
    internalDescription: new FormControl('') ,
    eventTypeId: new FormControl('' , Validators.required) ,
    credits: new FormControl('') ,
    userId: new FormControl('') ,
    maxParticipants: new FormControl('') ,
    minParticipants: new FormControl('') ,
    gender: new FormControl('') ,
    targetGroup: new FormControl('') ,
    dates: new FormControl('') ,
    dateVisibleFrom: new FormControl('') ,
    endOfReservation: new FormControl('') ,
    reservationPossible: new FormControl(false)
  });
  type;
  public formErrors: any = {
    title: {} ,
    description: {} ,
    eventTypeId: {}
  };

  constructor (public dialogRef: MatDialogRef<UserDialog> ,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    if (data.item.tg.length) {
      data.item.targetGroup = [];
      for (let i = 0; i < data.item.tg.length; i++) {
        data.item.targetGroup.push(data.item.tg[ i ].id);
      }
    }
    this.form.patchValue(data.item);
    this.type = data.item.type;
  }

  onNoClick (type): void {
    if (type === 'close') {
      this.dialogRef.close();
    }

    if (type === 'change') {
      let data = this.form.getRawValue();
      data.type = this.type;
      data.user = this.data.users.find(o => o.id === data.userId);
      if (data.targetGroup.length) {
        data.tg = [];
        for (let i = 0; i < data.targetGroup.length; i++) {
          data.tg.push(this.data.targetGroups.find(o => o.id === data.targetGroup[ i ]));
        }
      }
      this.dialogRef.close(data);
    }
  }

  get f () {
    return this.form.controls;
  }

  changeEventLevel (event) {
    console.log(event.value);
    this.type = this.data.eventTypes.find(o => o.id === event.value);
  }
}

